import React from "react";

function GoogleCalendarButton({ user, environment }) {
  const clientId =
    "369270661203-t3e34o7298k2eivjvt2342cnol4vqhu7.apps.googleusercontent.com";
  const redirectUri =
    "https://www.cloud.ditochat.com/api/connections/oauth2callback.php";
  const scope = encodeURIComponent(
    "openid email https://www.googleapis.com/auth/calendar"
  );

  // Übergib sowohl userId als auch environment im state
  const state = encodeURIComponent(
    JSON.stringify({ userId: user?.id, environment })
  );

  const handleClick = () => {
    const url = `https://accounts.google.com/o/oauth2/v2/auth?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&access_type=offline&prompt=consent&state=${state}`;
    window.location.href = url;
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
      }}
      onClick={handleClick}>
      + Google Kalender verbinden {environment}
    </div>
  );
}

export default GoogleCalendarButton;
